import { HomepagePromotionMobile } from 'components/eventView/addons/homepagePromotion/HomepagePromotionMobile';
import { EventViewData } from 'components/eventView/pages/eventData';
import {
    BaterCompetitionLink,
    BaterFooter,
    BaterPCHeader
} from 'components/eventView/pages/eventData/bater2024/bater2024Components';
import {
    BATER_BRANDS,
    BOAT_TYPE_CATEGORIES,
    MOTOR_TYPE_NAME_TO_ID
} from 'components/eventView/pages/eventData/bater2024/bater2024Config';
import styled from 'styled-components/macro';

export const Bater2024Event: EventViewData = {
    eventId: 'bater2024',
    mapId: '2a7cb374-cdfe-432f-9e66-e87619ba44b7',
    guideId: '837d5509-78ca-46c0-b483-22be789934e7',
    mapSettings: {
        standZoom: 0.6
    },
    filterSettings: {
        '89af6ddc-a1f1-4d9c-9c93-dbdbe09f28c6': {
            type: 'complex',
            filters: [
                {
                    filterId: 'boat_type',
                    title: 'Båttype',
                    optionIds: BOAT_TYPE_CATEGORIES.map((e) => e.worldMapSetId)
                },
                {
                    filterId: 'motor_type',
                    title: 'Motortype',
                    optionIds: Object.values(MOTOR_TYPE_NAME_TO_ID)
                },
                {
                    filterId: 'brands',
                    title: 'Båtmerker',
                    optionIds: BATER_BRANDS
                }
            ]
        }
    },
    eventInfo: {
        noNumbers: true,
        homepageContent: {
            footer: () => <BaterFooter />,
            'custom-block-buttons-1': () => (
                <S_HomepagePromotionMobile listId="1677f0a9-e5ad-4d74-bc46-f78696dc07f6" />
            ),
            'custom-block-buttons-2': () => <BaterCompetitionLink />,
            'bater-pc-header': () => <BaterPCHeader />
        },
        order: {
            normalV2: [
                ['89af6ddc-a1f1-4d9c-9c93-dbdbe09f28c6', 'map'],
                ['custom-block-buttons-1'],
                ['d06c565a-00aa-49f6-9981-cba1fbcbae7a', 'information', 'program', '...'],
                ['custom-block-buttons-2']
            ],
            mobile: [
                'home',
                '89af6ddc-a1f1-4d9c-9c93-dbdbe09f28c6',
                'map',
                'program',
                'information'
            ],
            wide: [
                'home',
                'bater-pc-header',
                '89af6ddc-a1f1-4d9c-9c93-dbdbe09f28c6',
                'd06c565a-00aa-49f6-9981-cba1fbcbae7a',
                'information',
                'program',
                '1677f0a9-e5ad-4d74-bc46-f78696dc07f6',
                'bd9d623a-65b3-4612-97c2-5c2a61fb8f50',
                '50d99d94-316c-4e84-a0be-e300da76bae1',
                '...',
                'map'
            ]
        },
        newsletter: {
            title: 'Meld deg på Norboat nyhetsbrev',
            description: 'Gå aldri glipp av en ny avtale',
            formId: '4adf33f5-64e3-442c-8cd8-987dd3603447',
            color: '#fff',
            backgroundColor: '#404A72',
            buttonBgColor: '#37416B',
            thankYouText: 'Takk for at du abonnerer på nyhetsbrevet'
        }
    }
};

const S_HomepagePromotionMobile = styled(HomepagePromotionMobile)`
    margin: 10px -20px 20px -0px;
    width: calc(100% + 20px);
    box-sizing: border-box;
`;
